import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

import { getTrans as t } from "../../../Localization/translations";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import authHeader from "../../../services/auth-header";
import { API } from "../../../backend";

function AddAccount() {
  const navigate = useNavigate();
  const form = useRef();
  const checkBtn = useRef();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [accountClasses, setAccountClasses] = useState([]);
  const [subClasses, setSubClasses] = useState([]);

  useEffect(() => {
    axios
      .get(API + "accounting/account-classes/", { headers: authHeader() })
      .then((res) => setAccountClasses(res.data || []))
      .catch(() => setAccountClasses([]));
  }, []);

  const loadSubClasses = (classId) => {
    if (!classId) {
      setSubClasses([]);
      return;
    }

    axios
      .get(`${API}accounting/account-subclasses/?class_id=${classId}`, {
        headers: authHeader(),
      })
      .then((res) => setSubClasses(res.data.data || res.data || []))
      .catch(() => setSubClasses([]));
  };

  const handleRegister = (data) => {
    setLoading(true);
    setDisable(true);
    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      const payload = {
        account_code: data.account_code,
        account_number: data.account_number,
        account_class: data.account_class || null,
        account_subclass: data.account_subclass || null,
        manual: data.manual,
        active: data.active,
      };

      axios
        .post(API + "accounting/account-create/", payload, {
          headers: authHeader(),
        })
        .then((response) => {
          toast.success("Account created successfully", {
            autoClose: 1000,
          });
          setLoading(false);
          setTimeout(() => {
            setDisable(false);
            navigate("/accounts");
          }, 1500);
        })
        .catch(() => {
          toast.error("Error creating account");
          setLoading(false);
          setDisable(false);
        });
    }
  };

  return (
    <>
      <div className="container-fluid pt-2">
        <ToastContainer />
        <div className="header pb-0 mb-3">
          <h5 className="tc">{t("Add Account")}</h5>
        </div>

        <div className="card">
          <div className="card-body">
            <Form
              onSubmit={handleSubmit(handleRegister)}
              ref={form}
              id="AddAccountForm"
            >
              <>
                {/* Row 1 */}
                <div className="form-group row">
                  <div className="col-sm-6">
                    <label className="col-form-label required">
                      {t("Account Name")}
                      <Tooltip content="Unique account identifier">
                        <i className="fa fa-light fa-circle-info ms-1"></i>
                      </Tooltip>
                    </label>
                    <input
                      className="form-control"
                      {...register("account_code", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors.account_code && "Account Name is required"}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <label className="col-form-label required">
                      {t("Account Number")}
                      <Tooltip content="Account number reference">
                        <i className="fa fa-light fa-circle-info ms-1"></i>
                      </Tooltip>
                    </label>
                    <input
                      className="form-control"
                      {...register("account_number", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors.account_number && "Account Number is required"}
                    </div>
                  </div>
                </div>

                {/* Row 2 */}
                <div className="form-group row">
                  <div className="col-sm-6">
                    <label className="col-form-label">
                      {t("Account Class")}
                    </label>
                    <select
                      className="form-control"
                      {...register("account_class")}
                      onChange={(e) => loadSubClasses(e.target.value)}
                    >
                      <option value="">Select Class</option>
                      {accountClasses.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.class_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-sm-6">
                    <label className="col-form-label">
                      {t("Account Subclass")}
                    </label>
                    <select
                      className="form-control"
                      {...register("account_subclass")}
                    >
                      <option value="">Select Subclass</option>
                      {subClasses.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.subclass_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Row 3 */}
                <div className="form-group row">
                  <div className="col-sm-6">
                    <label className="col-form-label">{t("Manual")}</label>
                    <select className="form-control" {...register("manual")}>
                      <option value="Y">Yes</option>
                      <option value="N">No</option>
                    </select>
                  </div>

                  <div className="col-sm-6">
                    <label className="col-form-label">{t("Enabled")}</label>
                    <select className="form-control" {...register("active")}>
                      <option value="Y">Yes</option>
                      <option value="N">No</option>
                    </select>
                  </div>
                </div>

                {/* Buttons */}
                <div className="text-left py-4">
                  <Link to="/accounts">
                    <button type="button" className="btn btn-secondary btn-md">
                      {t("Cancel")}
                    </button>
                  </Link>
                  &nbsp;&nbsp;
                  <button
                    type="submit"
                    disabled={disable}
                    className="border-0 btn btn-primary btn-gradient-primary btn-md"
                  >
                    {loading ? <ButtonLoading /> : t("Save")}
                  </button>
                </div>
              </>

              <CheckButton style={{ display: "none" }} ref={checkBtn} />
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddAccount;